<div class="page-content">
  <ng-container *ngIf="series$ | async">
    <app-page-loader type="series" *ngIf="loading$ | async"></app-page-loader>
    <div class="page-header no-margin-bottom" *ngIf="!(loading$ | async)">
      <div class="container-fluid">
        <h2 class="h5 no-margin-bottom">{{ (series$ | async).series ? (series$ | async).series.title : '' }}</h2>
      </div>
    </div>
    <div class="container-fluid" *ngIf="!(loading$ | async)">
      <div class="row">
        <div class="col-md-4 col-8">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="searchString"
            placeholder="Search.."
            style="margin-top: 20px"
          />
        </div>
        <div class="col-md-1 col-4">
          <button class="btn btn-primary" style="margin-top: 20px" type="button" (click)="search()">Search</button>
        </div>
      </div>
    </div>
    <section class="no-padding-top" id="videos-wrapper">
      <div
        fxLayout="row wrap"
        fxLayoutGap="16px"
        fxLayoutAlign="start start"
        class="mt-10 pt-2"
        id="videos-container"
        *ngIf="!(loading$ | async) && (videos$ | async) as aVideos"
      >
        <div
          class="card"
          fxFlex="0 0 calc(25% - 16px)"
          fxFlex.md="calc(33% - 16px)"
          fxFlex.sm="calc(50% - 16px)"
          fxFlex.xs="calc(100% - 16px)"
          *ngFor="let item of aVideos; let i = index"
        >
          <div class="video-item">
            <ng-container *ngIf="item.type === 'PAID'">
              <ng-container *ngIf="item.type === 'PAID' && !planStatus(plan)">
                <div class="mask" [routerLink]="['/subscription']"></div>
                <img [src]="item.thumbnail" alt="" class="s-watch" />
                <div class="tag-watch">
                  Premium Access Only
                </div>
              </ng-container>
              <ng-container *ngIf="item.type === 'PAID' && planStatus(plan)">
                <ng-container *ngIf="item.isEmbed">
                  <div [innerHtml]="item.link | safe: 'html'"></div>
                </ng-container>
                <ng-container *ngIf="!item.isEmbed">
                  <div [innerHtml]="videoHtml(item.link)"></div>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="item.type === 'FREE'">
              <ng-container *ngIf="item.isEmbed">
                <div [innerHtml]="item.link | safe: 'html'" class="external"></div>
              </ng-container>
              <ng-container *ngIf="!item.isEmbed">
                <div [innerHtml]="videoHtml(item.link)"></div>
              </ng-container>
            </ng-container>

            <div #player_container></div>
            <div class="card-body">
              <h5 class="card-title">{{ item.title }}</h5>
              <span class="card-category">{{ item.category.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="(videos$ | async).length === 0 && !(loading$ | async)">
        No videos found
      </ng-container>
    </section>
  </ng-container>
</div>
